import { makeVar } from "@apollo/client";

export const regStateVar = makeVar({
  main: 'UserEmail'
});